<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'OriginArchiveDisplay',
})
</script>
<template>
  <Descriptions v-if="data" layout="vertical" :column="1" size="middle">
    <Descriptions.Item label="保管单位">
      {{ data?.oldInfoDepartment }}
    </Descriptions.Item>
    <Descriptions.Item label="存放地址">
      {{ data?.oldInfoAddress }}
    </Descriptions.Item>
    <Descriptions.Item label="责任人">
      {{ data?.oldInfoPeople }}
    </Descriptions.Item>
    <Descriptions.Item label="联系方式">
      {{ data?.oldInfoPhone }}
    </Descriptions.Item>
  </Descriptions>
  <Empty v-else description="暂无填报" />
</template>

<script lang="ts" setup name="OriginArchiveDisplay">
import { Descriptions, Empty } from 'ant-design-vue'
defineProps<{
  data?: ApiOriginArchive.Item
}>()
</script>
